import React from 'react';
//react-icons
import { BiHomeAlt, BiUser } from 'react-icons/bi'
import { BsClipboardData, BsBriefcase, BsChatSquare } from 'react-icons/bs'
import{MdOutlineConnectWithoutContact} from 'react-icons/md'
//react-scroll
import { Link } from 'react-scroll';

const Nav = () => {
  return <nav className=' fixed bottom-2 lg:bottom-8 w-full overflow-hidden z-50 '>
    <div className=' container mx-auto '>
      <div className='w-full bg-[black]/40 h-[76px] backdrop-blur-2xl rounded-full max-w-[360px] mx-auto flex  px-5 justify-between text-2xl text-white/50 items-center'>
        <Link to='home'
          activeClass='active'
          smooth={true}
          spy={true}
          offset={-200}
          className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center'>
          <BiHomeAlt size={28} />
        </Link>
        <Link
          to='about'
          activeClass='active'
          smooth={true}
          spy={true}
          className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center'>
          <BiUser size={28} />
        </Link>
        <Link
          to='socails'
          activeClass='active'
          smooth={true}
          spy={true}
          className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center'>
          <MdOutlineConnectWithoutContact  size={36}/>
        </Link>
        {/* <Link
          to='work'
          activeClass='active'
          smooth={true}
          spy={true}
          className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center'>
          <BsBriefcase />
        </Link>
        <Link
          to='contact'
          activeClass='active'
          smooth={true}
          spy={true}
          className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center'>
          <BsChatSquare />
        </Link> */}
      </div>


    </div>
  </nav>;
};

export default Nav;
